import { render, staticRenderFns } from "./delete-contact.vue?vue&type=template&id=5c974f88&"
import script from "./delete-contact.vue?vue&type=script&lang=js&"
export * from "./delete-contact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/base/modals/delete-contact.vue
// module id = 1690
// module chunks = 0